/**
 * Компонент первого шага - выбор источника заказа
 *
 * Отображает сетку карточек с доступными источниками заказов:
 * - Звонок/Мессенджер
 * - Glovo
 * - Wolt
 * - Курьер
 * - Сотрудник
 */
import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { ORDER_SOURCES } from '../../../config/sourceFields';
import { SourceSelectionStepProps } from '../types';

/**
 * Иконки для каждого источника заказа
 */
const SOURCE_ICONS: Record<string, string> = {
  call_messenger: '📱',
  glovo: '🛵',
  wolt: '🚴',
  courier: '🚗',
  employee: '👨‍🍳',
};

export const SourceSelectionStep: React.FC<SourceSelectionStepProps> = ({
  onSourceSelect,
}) => {
  const { t, language } = useLanguage();

  return (
    <div className="min-h-screen bg-background-100 py-8">
      <div className="container-app max-w-4xl">
        {/* Заголовок страницы */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-text-primary mb-2">
            {t('addOrder.title')}
          </h1>
          <p className="text-text-secondary">
            {t('addOrder.selectSourceSubtitle')}
          </p>
        </div>

        {/* Сетка карточек источников */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {ORDER_SOURCES.map((source) => {
            const label = language === 'ru' ? source.label_ru : source.label_en;

            return (
              <button
                key={source.value}
                onClick={() => onSourceSelect(source.value)}
                className="card hover:shadow-lg hover:border-primary-500 transition-all p-6 text-center group"
              >
                {/* Иконка источника */}
                <div className="text-4xl mb-3 group-hover:scale-110 transition-transform">
                  {SOURCE_ICONS[source.value]}
                </div>
                {/* Название источника */}
                <h3 className="text-lg font-semibold text-text-primary">
                  {label}
                </h3>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
